module.exports = __webpack_public_path__ + "media/images/article/2022_head-558906e2a65203714cfe44642546e3e8.png";